<template>
  <fieldset class="c-signature-field">
    <CLegend>{{ $t('signature.title') }}</CLegend>

    <CShelf v-if="info" class="u-medium u-mb-1">
      <CIcon name="info" :size="20"/>
      {{ info }}
    </CShelf>

    <CSignatureInput @update:value="(value) => model = value?.split('data:image/jpeg;base64,')[1] ?? null"/>
  </fieldset>
</template>

<script setup lang="ts">
  import CIcon from '../CIcon.vue';
  import CShelf from '../CShelf.vue';
  import CLegend from './CLegend.vue';
  import CSignatureInput from './CSignatureInput.vue';

  defineProps<{
    info?: string,
  }>();

  const model = defineModel();
</script>
